module.exports = __webpack_public_path__ + "img/rejected.7f702dc3.svg";